var _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNeotubemobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 604,
    height: 604,
    viewBox: "0 0 604 604",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M293.024 154.271C320.241 127.055 366.714 139.507 376.676 176.686L430.831 378.796C440.793 415.975 406.773 449.995 369.594 440.033L167.484 385.878C130.305 375.916 117.853 329.443 145.069 302.227L293.024 154.271Z",
    fill: "url(#paint0_linear_334_20)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M258.359 155.853C277.604 122.519 325.717 122.519 344.962 155.853L449.582 337.06C468.827 370.393 444.77 412.06 406.28 412.06H197.04C158.55 412.06 134.494 370.393 153.739 337.06L258.359 155.853Z",
    fill: "url(#paint1_linear_334_20)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M337.027 153.704C370.361 134.459 412.027 158.515 412.027 197.005L412.027 406.245C412.027 444.735 370.361 468.791 337.027 449.546L155.82 344.926C122.487 325.681 122.487 277.569 155.82 258.324L337.027 153.704Z",
    fill: "url(#paint2_linear_334_20)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M355.078 293.337C361.745 297.186 361.745 306.809 355.078 310.658L282.956 352.298C276.289 356.147 267.956 351.335 267.956 343.637L267.956 260.358C267.956 252.66 276.289 247.848 282.956 251.697L355.078 293.337Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M316.281 295.913C321.006 298.596 321.006 305.404 316.281 308.087L291.707 322.043C287.04 324.693 281.25 321.322 281.25 315.956L281.25 288.044C281.25 282.678 287.04 279.307 291.707 281.957L316.281 295.913Z",
    fill: "#9517E2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_334_20",
    x1: 340.689,
    y1: 144.993,
    x2: 239.965,
    y2: 519.596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9517E2",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.928557,
    stopColor: "#D7177F",
    stopOpacity: 0.25
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_334_20",
    x1: 301.998,
    y1: 134.554,
    x2: 301.66,
    y2: 522.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9517E2",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.928557,
    stopColor: "#D7177F",
    stopOpacity: 0.25
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_334_20",
    x1: 385.469,
    y1: 157.078,
    x2: 191.222,
    y2: 492.848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9517E2",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.928557,
    stopColor: "#D7177F",
    stopOpacity: 0.25
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeotubemobile);
export default __webpack_public_path__ + "static/media/NEO TUBE MOBILE.ccd89e222fe9301b7b4d7dc2eafd9397.svg";
export { ForwardRef as ReactComponent };